(function () {
    'use strict';
    angular.module('app').directive('selectioncommandacquirecheckoutonelib', selectioncommand_acquirecheckoutonelib);
    function selectioncommand_acquirecheckoutonelib() {
        var directive = {
            link: link,
            restrict: 'EA',
            scope: {
                acquireCheckOutOneLibDialogShown: '=?'
            },
            controller: 'acquirecheckoutonelib',
            templateUrl: 'app/selectioncommand/selectioncommand_acquirecheckoutonelib.html'
        };
        return directive;
        function link(scope, element, attrs) {
        }
    }
})();